// Per-draw invoice pricing.
//
// The invoice line total for a blood file is submissions.invoice_price. New
// draws default to MIN_DRAW_PRICE ($23), which is also a hard floor enforced
// when editing the price or creating an invoice. Historical draws were
// backfilled with their exact old line total (see add_invoice_price.sql) and
// are shown as-is, so this getter does NOT clamp — the floor lives at the
// edit/create boundary, not on display.

export const MIN_DRAW_PRICE = 23;

// Line total for a single draw. NULL/blank → default $23.
export function effectiveDrawPrice(sub) {
  const p = parseFloat(sub?.invoice_price);
  return Number.isFinite(p) && p >= 0 ? p : MIN_DRAW_PRICE;
}

// Clamp a user-entered/created price to the floor. Use when saving an edit or
// stamping a price at invoice-creation time.
export function flooredPrice(value) {
  const p = parseFloat(value);
  if (!Number.isFinite(p) || p < MIN_DRAW_PRICE) return MIN_DRAW_PRICE;
  return p;
}
